import {Button, Grid} from "@material-ui/core";
import ButtonWithProgress from "../../../../../../ui/buttons/button-with-progress/ButtonWithProgress";
import PropTypes from "prop-types";

const InviaNuovoEmailDialogActions = (props) => {
    return (
        <Grid container justifyContent='space-between'>
            <Button variant='outlined'
                    onClick={() => props.onClickBackButton()}
                    color='primary'>{props.backButtonText}</Button>
            <ButtonWithProgress variant='contained'
                                handleClick={() => props.onClickNextButton()}
                                loading={props.loading ? props.loading : false}
                                text={props.nextButtonText}
                                disabled={props.disabled}
                                color='primary'/>
        </Grid>
    )
}

InviaNuovoEmailDialogActions.propTypes = {
    backButtonText: PropTypes.string.isRequired,
    nextButtonText: PropTypes.string.isRequired,
    onClickBackButton: PropTypes.func.isRequired,
    onClickNextButton: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
}

export default InviaNuovoEmailDialogActions;


